import React from 'react';
import { useMutation, gql } from '@apollo/client';
import { Button, toaster,TrashIcon } from 'evergreen-ui';

const DELETE_DEBT_MUTATION = gql`
  mutation Debt_delete($debtId: ID!) {
    debt_delete(debtId: $debtId) {
      _id
      title
    }
  }
`;

const DeleteDebtButton = ({ debtId }) => {
  const [deleteDebt, { loading }] = useMutation(DELETE_DEBT_MUTATION, {
    onCompleted: (data) => {
      // toaster.success(`Debt with ID ${data.debt_delete._id} deleted successfully.`);
      toaster.success(`Debt deleted successfully.`);
      window.location.reload()
    },
    onError: (err) => {
      toaster.danger(`Failed to delete debt: ${err.message}`);
    },
  });

  const handleDelete = () => {
    if (!debtId) {
      toaster.warning('Debt ID is required.');
      return;
    }
    deleteDebt({ variables: { debtId } });
  };

  return (
    <Button
      appearance="primary"
      intent="danger"
      isLoading={loading}
      onClick={handleDelete}
    >
      <TrashIcon />
    </Button>
  );
};

export default DeleteDebtButton;
